import app, { Component } from 'apprun';
import { users } from '../api';

export default class CommonPropertyComponent extends Component {
    state = { auditLog: [] };

    view = (state) => {
      if (!state.item) { return; }
      return (
        <form class="form-horizontal" style={{ width: '600px' }}>

          {state.item.fieldName === 'TeamMemberAuditLog' ?
            <div>
              <p>Update History</p>
              <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
                <thead>
                  <tr>
                    <th>Team Name</th>
                    <th>Billing Lead</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Modified Date</th>
                    <th>Modified User</th>
                  </tr>
                </thead>
                <tbody>
                  {state.auditLog.map((item) => {
                    return (
                      <tr style={{ display: 'table-row' }}>
                        <td>{item.teamName}</td>
                        <td>{item.billingLeadIndDesp}</td>
                        <td>{item.startDate?.substring(0, 10)}</td>
                        <td>{item.endDate?.substring(0, 10)}</td>
                        <td>{item.modifiedDate?.substring(0, 10)}</td>
                        <td>{item.auditModifiedUser}</td>
                      </tr>
                    );
                  }
                  )}
                </tbody>
              </table></div> : ''}

          {state.item.fieldName === 'PrimaryLocation' ?
            <div>
              <p>Update History</p>
              <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
                <thead>
                  <tr>
                    <th>Location ID</th>
                    <th>Location Name</th>
                    <th>Modified Date</th>
                    <th>Modified User</th>
                  </tr>
                </thead>
                <tbody>
                  {state.auditLog.map((item) => {
                    return (
                      <tr style={{ display: 'table-row' }}>
                        <td>{item.locationID}</td>
                        <td>{item.locationName}</td>
                        <td>{item.modifiedDate?.substring(0, 10)}</td>
                        <td>{item.auditModifiedUser}</td>
                      </tr>
                    );
                  }
                  )}
                </tbody>
              </table></div> : ''}

          {state.item.fieldName === 'MovementAuditLog' ? <div>
            <p>Update History</p>
            <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
              <thead>
                <tr>
                  <th>Company Person ID</th>
                  <th>Company Name</th>
                  <th>Employee Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Modified Date</th>
                  <th>Modified User</th>
                </tr>
              </thead>
              <tbody>
                {state.auditLog.map((item) => {
                  return (
                    <tr style={{ display: 'table-row' }}>
                      <td>{item.companyPersonID}</td>
                      <td>{item.companyName}</td>
                      <td>{item.employeeType}</td>
                      <td>{item.startDate?.substring(0, 10)}</td>
                      <td>{item.endDate?.substring(0, 10)}</td>
                      <td>{item.modifiedDate?.substring(0, 10)}</td>
                      <td>{item.auditModifiedUser}</td>
                    </tr>
                  );
                }
                )}
              </tbody>
            </table></div> : ''}

        </form>
      );
    };

    update = {
      refresh: async (state, newState) => {
        state = newState;

        if (state.item.fieldName === 'TeamMemberAuditLog') {
          state.auditLog = await users.getAuditTeamMember(state.personId);
        } else if (state.item.fieldName === 'MovementAuditLog') {
          state.auditLog = await users.getAuditNetworkMovement(state.personId);
        }

        return { ...state, newVal: newState.item.value };
      },

      save: (state) => {
        state.caller.run(state.save, state.item, state.panelId, state.newVal);
      },
    };

    mounted = ({ state }) => {
      this.run('refresh', state);
    };
}
